import { ARRAY, STRING } from '../../../utils/component-validations';
import { COMPONENT_STATE_ARGS, pickArgs } from '../../../utils/spds/metadata';
import Container from './container.gjs';
import FlexColumn from '../layout/flex/column.gjs';
import Super from './base.gjs';
import styles from './helper-text.module.scss';

const METADATA = {
  component: 'Spds::Core::HelperText',
  description: `
    Helper text for SPDS inputs.

    ### Displaying errors

    The helper text can display an error state in one of two ways:

    * Pass the \`@error\` argument with a value of \`true\`. This will display the error state with whatever text is otherwise displayed
    * Pass the \`@errors\` argument as an array of strings representing the errors that should be displayed. This will override the default text
  `,
  meta: {
    ...pickArgs(COMPONENT_STATE_ARGS, ['error']).meta,
    errors: {
      description: 'Array of error messages to display',
      type: ARRAY,
    },
    helperText: {
      description: 'Helper text to display',
      initialValue: 'Helper text',
      type: STRING,
    },
  },
  name: 'Helper Text',
  resources: {
    github:
      'https://github.com/simplepractice/ember-simplepractice/blob/staging/addon/src/components/spds/core/helper-text.gjs',
  },
};

export default class SpdsCoreHelperText extends Super {
  static metadata = this.setMetadata(METADATA);
  baseClass = 'spds-helper-text';
  classesToMapToAttrs = ['error'];
  styles = styles;

  get error() {
    return this.args.error ?? this.errors.length > 0;
  }

  get errors() {
    return this.args.errors ?? [];
  }

  <template>
    <FlexColumn
      @content={{@helperText}}
      class={{this.classes}}
      data-test-spds-helper-text
      id={{this.id}}
      {{this.validateArguments}}
      ...attributes
    >
      {{#if this.errors}}
        {{#each this.errors as |error index|}}
          <Container @content={{error}} data-test-spds-helper-text-error={{index}} />
        {{/each}}
      {{else}}
        {{yield}}
      {{/if}}
    </FlexColumn>
  </template>
}

export const SPDS_CORE_HELPER_TEXT_METADATA = SpdsCoreHelperText.metadata;
